var _defs, _polygon, _polygon2, _g, _path, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "95px",
    viewBox: "0 0 99 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "6.807467 20.6308557 70.6592549 9.37207969 78.0019798 51.0145255 14.1501919 62.2733955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "3.45733738 24.3505104 72.4309264 12.188624 80.36264 57.171373 11.3890509 69.3333609"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.5%",
    y: "-13.1%",
    width: "116.9%",
    height: "122.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "6.5661399 28.0229912 70.4179278 16.7642153 77.7606527 58.4066611 13.9088648 69.6655311"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "68.9775441%",
    x2: "20.3801612%",
    y2: "24.9196813%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61EAB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "32.5987215 83.2701287 35.3152817 83.2701287 35.3152817 82.3646087 32.5987215 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "48.8980823 83.2701287 51.6146425 83.2701287 51.6146425 82.3646087 48.8980823 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "43.4649621 83.2701287 46.1815222 83.2701287 46.1815222 82.3646087 43.4649621 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-12",
    points: "38.0318418 83.2701287 40.7484019 83.2701287 40.7484019 82.3646087 38.0318418 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-14",
    points: "59.7643228 83.2701287 62.480883 83.2701287 62.480883 82.3646087 59.7643228 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-16",
    points: "65.1974431 83.2701287 67.9140032 83.2701287 67.9140032 82.3646087 65.1974431 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-18",
    points: "54.3312026 83.2701287 57.0477627 83.2701287 57.0477627 82.3646087 54.3312026 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-20",
    points: "1.9347097e-14 83.2701287 2.71656013 83.2701287 2.71656013 82.3646087 1.9347097e-14 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-22",
    points: "5.43312026 83.2701287 8.14968039 83.2701287 8.14968039 82.3646087 5.43312026 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-24",
    points: "27.1656013 83.2701287 29.8821614 83.2701287 29.8821614 82.3646087 27.1656013 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-26",
    points: "21.732481 83.2701287 24.4490412 83.2701287 24.4490412 82.3646087 21.732481 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-27"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-28",
    points: "10.8662405 83.2701287 13.5828006 83.2701287 13.5828006 82.3646087 10.8662405 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-29"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-30",
    points: "16.2993608 83.2701287 19.0159209 83.2701287 19.0159209 82.3646087 16.2993608 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-31"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-32",
    points: "76.0636836 83.2701287 78.7802437 83.2701287 78.7802437 82.3646087 76.0636836 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-33"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-34",
    points: "70.6305634 83.2701287 73.3471235 83.2701287 73.3471235 82.3646087 70.6305634 82.3646087"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-35"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-36",
    points: "83.307844 72.4038882 84.213364 72.4038882 84.213364 69.6873281 83.307844 69.6873281"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-37"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-38",
    points: "83.307844 77.8370085 84.213364 77.8370085 84.213364 75.1204483 83.307844 75.1204483"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-39"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-40",
    points: "83.307844 66.970768 84.213364 66.970768 84.213364 64.2542078 83.307844 64.2542078"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-41"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-42",
    points: "83.307844 61.5376477 84.213364 61.5376477 84.213364 58.8210876 83.307844 58.8210876"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-43"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-44",
    points: "83.307844 47.954847 84.213364 47.954847 84.213364 45.2382869 83.307844 45.2382869"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-45"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-46",
    points: "83.307844 53.3879673 83.307844 56.1045274 84.213364 56.1045274 84.213364 53.3879673 84.213364 50.6714072 83.307844 50.6714072"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-9.2%",
    width: "210.4%",
    height: "136.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-47"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-48",
    points: "83.307844 37.0886065 84.213364 37.0886065 84.213364 34.3720464 83.307844 34.3720464"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-49"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-50",
    points: "83.307844 31.6554863 84.213364 31.6554863 84.213364 28.9389261 83.307844 28.9389261"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-51"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-52",
    points: "83.307844 42.5217268 84.213364 42.5217268 84.213364 39.8051667 83.307844 39.8051667"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-55.2%",
    y: "-18.4%",
    width: "210.4%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-53"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.4968039,82.3646087 L81.4968039,83.2701287 C82.9970695,83.2701287 84.213364,82.0538342 84.213364,80.5535686 L83.307844,80.5535686 C83.307844,81.553806 82.4970413,82.3646087 81.4968039,82.3646087",
    id: "path-54"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-18.4%",
    width: "136.8%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-55"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-56",
    points: "16.2993608 24.4113259 19.0159209 24.4113259 19.0159209 23.5058059 16.2993608 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-57"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-58",
    points: "5.43312026 24.4113259 8.14968039 24.4113259 8.14968039 23.5058059 5.43312026 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-59"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-60",
    points: "1.9347097e-14 24.4113259 2.71656013 24.4113259 2.71656013 23.5058059 1.9347097e-14 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-61"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-62",
    points: "10.8662405 24.4113259 13.5828006 24.4113259 13.5828006 23.5058059 10.8662405 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-63"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-64",
    points: "48.8980823 24.4113259 51.6146425 24.4113259 51.6146425 23.5058059 48.8980823 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-65"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-66",
    points: "76.0636836 24.4113259 78.7802437 24.4113259 78.7802437 23.5058059 76.0636836 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-67"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-68",
    points: "65.1974431 24.4113259 67.9140032 24.4113259 67.9140032 23.5058059 65.1974431 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-69"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-70",
    points: "70.6305634 24.4113259 73.3471235 24.4113259 73.3471235 23.5058059 70.6305634 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-71"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-72",
    points: "59.7643228 24.4113259 62.480883 24.4113259 62.480883 23.5058059 59.7643228 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-73"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-74",
    points: "54.3312026 24.4113259 57.0477627 24.4113259 57.0477627 23.5058059 54.3312026 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-75"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-76",
    points: "43.4649621 24.4113259 46.1815222 24.4113259 46.1815222 23.5058059 43.4649621 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-77"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-78",
    points: "27.1656013 24.4113259 29.8821614 24.4113259 29.8821614 23.5058059 27.1656013 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-79"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-80",
    points: "32.5987215 24.4113259 35.3152817 24.4113259 35.3152817 23.5058059 32.5987215 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-81"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-82",
    points: "21.732481 24.4113259 24.4490412 24.4113259 24.4490412 23.5058059 21.732481 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-83"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-84",
    points: "38.0318418 24.4113259 40.7484019 24.4113259 40.7484019 23.5058059 38.0318418 23.5058059"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-55.2%",
    width: "136.8%",
    height: "320.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-85"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.307844,26.222366 L84.213364,26.222366 C84.213364,24.7221004 82.9970695,23.5058059 81.4968039,23.5058059 L81.4968039,24.4113259 C82.4970413,24.4113259 83.307844,25.2221286 83.307844,26.222366",
    id: "path-86"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-18.4%",
    width: "136.8%",
    height: "173.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-87"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "68.9775441%",
    x2: "20.3801612%",
    y2: "24.9196813%",
    id: "linearGradient-88"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61EAB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.7409642,61.5376477 L69.7250433,61.5376477 C68.2247777,61.5376477 67.0084832,60.3213532 67.0084832,58.8210876 L67.0084832,47.954847 C67.0084832,46.4545814 68.2247777,45.2382869 69.7250433,45.2382869 L88.7409642,45.2382869 L88.7409642,61.5376477 Z",
    id: "path-89"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.2%",
    y: "-30.7%",
    width: "164.4%",
    height: "185.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-90"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "0%",
    fx: "50%",
    fy: "0%",
    r: "100%",
    id: "radialGradient-91"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: "0.0580658784%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.5912838,53.3879673 C80.5912838,56.3885891 78.1587853,58.8210876 75.1581636,58.8210876 C72.1575418,58.8210876 69.7250433,56.3885891 69.7250433,53.3879673 C69.7250433,50.3873455 72.1575418,47.954847 75.1581636,47.954847 C78.1587853,47.954847 80.5912838,50.3873455 80.5912838,53.3879673",
    id: "path-92"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-64.4%",
    y: "-46.0%",
    width: "228.8%",
    height: "228.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-93"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Dashboard_2nd_view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH-_2nd-Nav-3a",
    transform: "translate(-195.000000, -3773.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(198.585526, 3775.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1",
    transform: "translate(44.414474, 43.000000) rotate(-9.000000) translate(-44.414474, -43.000000) "
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D1F3A9",
    points: "7.94584783 23.9456985 68.2976721 7.77446878 78.8441735 47.1344368 18.4922587 63.3056665"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#F8F8F8",
    transform: "translate(42.151316, 33.368857) rotate(-7.000000) translate(-42.151316, -33.368857) ",
    points: "3.69866448 16.9583748 72.6722535 4.79648844 80.6039671 49.7792374 11.630378 61.9412253"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill-8",
    transform: "translate(42.404723, 35.822738) rotate(-7.000000) translate(-42.404723, -35.822738) "
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#979797",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#5AEBB8",
    xlinkHref: "#path-1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6881633,53.767924 L17.4740626,71.5099813 L5.64605604,27.3672475 L70.9405403,9.8715891 C71.4483811,9.73553651 71.9705031,10.0369658 72.1065557,10.5448066 L83.6881633,53.767924 Z",
    id: "Fill-5",
    fill: "#FF5100",
    transform: "translate(44.667110, 40.674455) rotate(9.000000) translate(-44.667110, -40.674455) "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Copy",
    transform: "translate(41.909989, 40.760992) rotate(-7.000000) translate(-41.909989, -40.760992) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Copy-2",
    transform: "translate(42.163396, 43.214873) rotate(-7.000000) translate(-42.163396, -43.214873) "
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#979797",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#5AEBB8",
    xlinkHref: "#path-4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4968039,85.9866889 L2.71656013,85.9866889 C1.21629452,85.9866889 1.04524576e-13,84.7703943 1.04524576e-13,83.2701287 L1.04524576e-13,23.5058059 C1.04524576e-13,22.0055403 1.21629452,20.7892458 2.71656013,20.7892458 L81.4968039,20.7892458 C84.4974256,20.7892458 86.9299241,23.2217442 86.9299241,26.222366 L86.9299241,80.5535686 C86.9299241,83.5541904 84.4974256,85.9866889 81.4968039,85.9866889",
    id: "Fill-12",
    fill: "url(#linearGradient-5)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-16"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-18"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-19"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-21"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-22"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-23"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-24"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-25"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-26"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-24"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-27"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-27)",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-26"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-28"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-28"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-29"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-31)",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-30"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-33)",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-32"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-31"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-35)",
    xlinkHref: "#path-34"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-34"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-32"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-37)",
    xlinkHref: "#path-36"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-36"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-33"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-39)",
    xlinkHref: "#path-38"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-38"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-34"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-41)",
    xlinkHref: "#path-40"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-40"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-35"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-43)",
    xlinkHref: "#path-42"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-42"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-36"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-45)",
    xlinkHref: "#path-44"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-44"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-37"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-47)",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-46"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-38"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-49)",
    xlinkHref: "#path-48"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-48"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-39"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-51)",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-50"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-40"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-53)",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-52"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-41"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-55)",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-54"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-42"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-57)",
    xlinkHref: "#path-56"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-56"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-43"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-59)",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-58"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-44"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-61)",
    xlinkHref: "#path-60"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-60"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-45"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-63)",
    xlinkHref: "#path-62"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-62"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-46"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-65)",
    xlinkHref: "#path-64"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-64"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-47"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-67)",
    xlinkHref: "#path-66"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-66"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-48"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-69)",
    xlinkHref: "#path-68"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-68"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-49"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-71)",
    xlinkHref: "#path-70"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-70"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-50"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-73)",
    xlinkHref: "#path-72"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-72"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-51"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-75)",
    xlinkHref: "#path-74"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-74"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-52"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-77)",
    xlinkHref: "#path-76"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-76"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-53"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-79)",
    xlinkHref: "#path-78"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-78"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-54"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-81)",
    xlinkHref: "#path-80"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-80"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-55"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-83)",
    xlinkHref: "#path-82"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-82"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-56"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-85)",
    xlinkHref: "#path-84"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-84"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-57"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-87)",
    xlinkHref: "#path-86"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-86"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.9299241,62.4431677 L70.6305634,62.4431677 C69.1302977,62.4431677 67.9140032,61.2268732 67.9140032,59.7266076 L67.9140032,48.8603671 C67.9140032,47.3601015 69.1302977,46.143807 70.6305634,46.143807 L86.9299241,46.143807 L86.9299241,62.4431677 Z",
    id: "Fill-59",
    fill: "#D9D9D9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.772415516
  }), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-61"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-90)",
    xlinkHref: "#path-89"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-88)",
    fillRule: "evenodd",
    xlinkHref: "#path-89"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80.5912838,54.2934873 C80.5912838,57.2941091 78.1587853,59.7266076 75.1581636,59.7266076 C72.1575418,59.7266076 69.7250433,57.2941091 69.7250433,54.2934873 C69.7250433,51.2928656 72.1575418,48.8603671 75.1581636,48.8603671 C78.1587853,48.8603671 80.5912838,51.2928656 80.5912838,54.2934873",
    id: "Fill-63",
    fill: "#D9D9D9",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-65"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-93)",
    xlinkHref: "#path-92"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-91)",
    fillRule: "evenodd",
    xlinkHref: "#path-92"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.968e6d55a4151be51bc56603c5d66fcd.svg";
export { ForwardRef as ReactComponent };